import { SelectEditor } from './select';

export const AgGridCellEditor = {
  Select: SelectEditor
};
